import { type IProduct } from '@recargas-dominicanas/core/types';
import { ProductsApi } from '@recargas-dominicanas/core/api';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from './store';

export const productSlice = createSlice({ 
  name: 'product',
  initialState: {
    loading: true,
    failed: false,
    products: [] as IProduct[]
  },
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFailed(state, action: PayloadAction<boolean>) {
      state.failed = action.payload;
    },
    setProducts(state, action: PayloadAction<IProduct[]>) {
      state.products = action.payload;
    }
  }
});

const { setLoading, setFailed, setProducts } = productSlice.actions;

export function useProductStore() {

  const state = useAppSelector(state => state.productsState);
  const dispatch = useAppDispatch();

  async function fetch() {
    try {
      dispatch(setLoading(true));
      dispatch(setFailed(false));
      const products = await ProductsApi.getProdutcs();
      dispatch(setProducts(products));
      dispatch(setLoading(false));
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      dispatch(setFailed(true));
    }
  }

  return {
    ...state,
    fetch
  };
}
